import { List, styled } from "@mui/material";

export const DiscList = styled(List)(() => ({
  listStyleType: "disc",
  padding: 0,
  paddingLeft: "30px",

  "& .MuiListItem-root": {
    margin: 0,
    padding: 0,
  },

  "& > li": {
    paddingY: 0,
    paddingLeft: "0px",
    display: "list-item",
    counterIncrement: null,
    "&::marker": {
      content: null,
    },
  },
}));
